import type { LeadPayload } from './types';

export type SubmitResult =
  | {type:'success'; requestId:string}
  | {type:'validation'|'forbidden'|'server'; message:string}
  | {type:'rate'; retryAfter:string}
  | {type:'network'};

const endpoint = () => {
  const developmentBase = process.env.NODE_ENV === 'development'
    ? (process.env.NEXT_PUBLIC_LEAD_API_BASE_URL ?? '').replace(/\/$/, '') : '';
  return `${developmentBase}/api/leads`;
};

export async function submitLead(payload: LeadPayload): Promise<SubmitResult> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 12_000);
  try {
    const response = await fetch(endpoint(), {
      method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload), signal:controller.signal,
    });
    const body: unknown = await response.json().catch(() => null);
    const record = body && typeof body === 'object' ? body as Record<string, unknown> : {};
    const safeMessage = typeof record.message === 'string' ? record.message : '';
    const requestId = typeof record.requestId === 'string' ? record.requestId : '';
    if (response.ok || response.status === 409) return {type:'success', requestId};
    if (response.status === 400) return {type:'validation', message:safeMessage || 'اطلاعات فرم نیاز به اصلاح دارد.'};
    if (response.status === 403 || response.status === 415) return {type:'forbidden', message:safeMessage || 'ارسال درخواست از این صفحه ممکن نیست.'};
    if (response.status === 429) return {type:'rate', retryAfter:response.headers.get('Retry-After') || 'کمی بعد'};
    return {type:'server', message:'ثبت درخواست موقتاً ممکن نیست.'};
  } catch {
    return {type:'network'};
  } finally {
    window.clearTimeout(timeout);
  }
}
